import React from 'react'
import { Card, Table, Tag } from 'antd'
import { FormComponent } from '../../../../BaseComponent'
import { DashboardProps } from '../types'

export default class DashboardSections extends FormComponent<DashboardProps> {
  tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => (
        <Tag color="purple">{text}</Tag>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text: string) => (
        <Tag color="blue">{text}</Tag>
      )
    },
  ]

  render() {
    return (
      <Card title="Sync Sections">
        <Table
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={this.props.context.preview?.sync_sections as any || []}
        />
      </Card>
    )
  }
}